import { render, staticRenderFns } from "./showQuestion.vue?vue&type=template&id=6a04f14e&scoped=true&"
import script from "./showQuestion.vue?vue&type=script&lang=js&"
export * from "./showQuestion.vue?vue&type=script&lang=js&"
import style0 from "./showQuestion.vue?vue&type=style&index=0&id=6a04f14e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a04f14e",
  null
  
)

export default component.exports